import loginBg from './login-bg-left.jpg';
import userIcon from './userIcon.png';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import DoneIcon from '@material-ui/icons/Done';
import AddIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import FavoriteIcon from '@material-ui/icons/Favorite';

import LineStyleOutlinedIcon from '@material-ui/icons/LineStyleOutlined';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import MovieCreationOutlinedIcon from '@material-ui/icons/MovieCreationOutlined';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Fishery from './fishery.svg'
import Garlic from './galic.svg'
import CropsGrains from './cropsGrains.svg'
import FruitsVegetables from './fruitsVegetables.svg'
import LivestockDairy from './livestockDairy.svg'
import FisheriesAquaculture from './fisheriesAquaculture.svg'
import AgriServicesInputs from './agriServicesInputs.svg'
import specialOffer from './specialOffer.svg'
import starFill from './starFill.svg'
import featureProduct from './featureProduct.svg'
import LogoText from './logo.PNG'
import service from './service.jpg'
import LogoIcon from './logoicon.PNG'
import PakFlag from './pakFlag.svg'
import UaeFlag from './uae.svg'
import arrowDown from './down-arrow.svg'
import placeHolder from './placeholder.svg'
import warning from './warning.svg'
import shoppingWithin from './shoppingWithin.svg'
import trustedSeller from './trustedSaller.svg'
import mail1 from './mail1.svg'
import mail2 from './mail1.png'
import social1 from './social01.png'
import social2 from './social03.png'
import social3 from './social05.png'
import social4 from './youtube1.png'
import social5 from './fb1.png'
import store from './store1.svg'
import totalUser from './totalUser.svg';
import insta from './insta.png'
import twitter from './twitter1.png'
import location from './location.svg'
import location1 from './location1.svg'
import phone from './phone.svg'
import leaf from './quill1.svg'
import linkedin from './linkedin.png'
import openBook from './open-book.svg'
import secure from './secure.svg'
import thumb from './thumb-up.svg'
import delivery from './delivery.svg'
import attachment from './attachment.svg'
import addProductStart from './addProductStart.png'
import bike from './bike.png'
import loc from './loc.svg'
import phone_green from './phone_green.svg'
import dollor from './dollor.svg'
import profileImg from './profileImg.png'
import notification1 from './notification1.svg'
import notification from './notification.png'
import sun from './sun.png'
import mater from './mater.svg'
import ticketStart from './TicketStar.svg'
import transfer from './transfer.svg'
import payment from './pngwing.png'
import stats from './stats.svg';
import banner from './banner.jpg';
import first from './1.jpg';
import second from './2.jpg';
import emptyStar from './emptyStar.png'

const Download = GetAppIcon;
const UploadFile = CloudUploadOutlinedIcon;
const NextIcon = NavigateNextIcon;
const SkipIcon = SkipNextIcon;
const BackIcon = ArrowBackIosIcon;
const ShoppingCart = ShoppingCartIcon;
export {
  userIcon, loginBg, Download, UploadFile, ClearIcon, NextIcon, SkipIcon, BackIcon, DoneIcon, EditIcon,
  LineStyleOutlinedIcon, PersonPinIcon, MovieCreationOutlinedIcon, AccountBalanceWalletOutlinedIcon, FavoriteIcon,
  ShoppingCart, Fishery, Garlic, specialOffer, starFill, featureProduct, LogoIcon, LogoText, PakFlag,UaeFlag,
  arrowDown,  placeHolder, warning, shoppingWithin, trustedSeller, mail1, mail2, social1, social4, social5, social3,
  social2,  store, insta, twitter, totalUser,location1,location,phone,leaf,linkedin,openBook,secure,thumb,delivery,
  attachment,  addProductStart ,notification1,emptyStar,DeleteIcon,AddIcon,service,
  bike,loc, phone_green,dollor,profileImg,notification,sun,mater,ticketStart,transfer,payment,stats,banner,first,second,
  CropsGrains, FruitsVegetables, LivestockDairy, FisheriesAquaculture, AgriServicesInputs,
}
